import { render, staticRenderFns } from "./ApprovalStepBadge.vue?vue&type=template&id=bbfe61b2"
import script from "./ApprovalStepBadge.vue?vue&type=script&lang=js"
export * from "./ApprovalStepBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports